<div class="panel">
  <div class="form-field" >
    <mat-form-field appearance="fill">
      <mat-label>{{ title }}</mat-label>
      <input matInput #input type="text" name="search" [(ngModel)]="searchText" (keyup)="onKeySearch($event)" autocomplete="off" [placeholder]="placeholder" 
      (focus)="onFocus()" (blur)="onFocus()"/>
      
      <button class="button-class" *ngIf="searchText && isFocused" matSuffix mat-icon-button aria-label="Clear" (click)="emptyValue()">
        <mat-icon>highlight_off</mat-icon>
      </button>
    </mat-form-field>
  </div>
</div>